/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Api from '@/api';
/* eslint-enable import/no-cycle */

const theState = {
    loading: false,
    processing: false,
    applications: [],
    showDialog: false,
    editApplication: {
        id: null,
        app: '',
        description: '',
        createdAt: null,
        updatedAt: null,
    },
};

const getters = {
    dialogTitle(state) {
        if (state.editApplication.id === null) {
            return 'Application hinzufügen';
        }
        return 'Application editieren';
    },
};

const actions = {
    getApplications({ commit }) {
        commit('setLoading', true);
        Api.application.getApplications()
            .then(({ data }) => {
                const applications = data.map(app => ({
                    ...app,
                    createdAt: app.created_at,
                    updatedAt: app.updated_at,
                }));
                commit('setApplications', applications);
            })
            .catch(() => {
                commit('setApplications', []);
            })
            .finally(() => {
                commit('setLoading', false);
            });
    },

    editApplicationById({ commit }, applicationId) {
        commit('setLoading', true);
        commit('editApplication', applicationId);
        return new Promise((resolve, reject) => {
            Api.application.getApplicationById(applicationId)
                .then(({ data }) => {
                    const application = {
                        ...data,
                        createdAt: data.created_at,
                        updatedAt: data.updated_at,
                    };
                    commit('setEditApplication', application);
                    resolve();
                })
                .catch(() => {
                    reject();
                    commit('closeDialog');
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        });
    },

    saveApplication({ commit, dispatch, state }) {
        commit('setLoading', true);
        commit('setProcessing', true);
        return new Promise((resolve, reject) => {
            if (state.editApplication.id !== null) {
                Api.application.updateApplication(state.editApplication)
                    .then(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        commit('closeDialog');
                        dispatch('getApplications');
                        resolve();
                    })
                    .catch(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        reject();
                    });
            } else {
                Api.application.addApplication(state.editApplication)
                    .then(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        commit('closeDialog');
                        dispatch('getApplications');
                        resolve();
                    })
                    .catch(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        reject();
                    });
            }
        });
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },

    setProcessing(state, processing) {
        state.processing = processing;
    },

    setApplications(state, applications) {
        state.applications = applications;
    },

    editApplication(state, applicationId) {
        Vue.set(state.editApplication, 'id', applicationId);
        state.showDialog = true;
    },

    setEditApplication(state, {
        id,
        app,
        description,
        created_at,
        updated_at,
    }) {
        Vue.set(state, 'editApplication', {
            id,
            app,
            description,
            createdAt: created_at,
            updatedAt: updated_at,
        });
    },

    closeDialog(state) {
        state.showDialog = false;
        Vue.set(state, 'editApplication', {
            id: null,
            app: '',
            description: '',
            createdAt: null,
            updatedAt: null,
        });
    },

    addApplication(state) {
        Vue.set(state.editApplication, 'id', null);
        state.showDialog = true;
    },

    updateApp(state, app) {
        Vue.set(state.editApplication, 'app', app);
    },
    updateDescription(state, description) {
        Vue.set(state.editApplication, 'description', description);
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
